"use client";
import { Instagram, Telegram, WhatsApp } from "@mui/icons-material";
import { Box, Card, Container, Divider, Grid, Stack, Typography, Link, IconButton, Button, Icon } from "@mui/material";
import Image from "next/image";
import NextLink from "next/link";
import QuickSendIcon from "../../_components/Icons/QuickSendIcon";
import HeadphoneIcon from "@/app/_components/Icons/HeadphoneIcon";
import GuaranteeIcon from "@/app/_components/Icons/GuaranteeIcon";
import BigCarIcon from "@/app/_components/Icons/BigCarIcon";
import { webEnv } from "@/environment/environment";
import { constants } from "@/environment/constants";
import InstagramIcon from "@/app/_components/Icons/InstagramIcon";
import { useBottomBar } from "@/app/(main)/_components/BottomBar/BottomBarProvider";

export default function SiteFooter() {
  const { state } = useBottomBar();
  return (
    <Stack component={"footer"} sx={{ pt: 3, pb: { xs: Boolean(state.content) ? 10 : 4.5, sm: 0 } }}>
      <Box sx={{ backgroundColor: "secondary.200" }}>
        <Container sx={{ p: { xs: 3, md: 3, lg: 4 } }} maxWidth={"xl"}>
          <Grid container spacing={{ xs: 4, md: 3 }}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Stack spacing={{ md: 2, xs: 1 }}>
                <Typography variant="h5" component={"section"}>
                  پشتیبانی
                </Typography>
                <Stack direction={"row"} alignItems={"center"} useFlexGap flexWrap={"wrap"} spacing={1}>
                  <Typography variant="subtitle1" component={"div"} sx={{ color: "grey.700" }}>
                    تماس :{" "}
                  </Typography>
                  <Link href={"tel:+989146672256"} underline="hover" variant="subtitle1" component={NextLink} dir={"ltr"}>
                    0914 667 22 56
                  </Link>
                  <Divider orientation="vertical" flexItem />
                  <Typography variant="subtitle1" component={"div"} sx={{ color: "grey.700" }}>
                    تلفن :{" "}
                  </Typography>
                  <Link href={"tel:+982186125827"} underline="hover" variant="subtitle1" component={NextLink} dir={"ltr"}>
                    021 86 12 58 27
                  </Link>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} useFlexGap flexWrap={"wrap"} spacing={1}>
                  <Typography variant="subtitle1" component={"div"} sx={{ color: "grey.700" }}>
                    ساعت کاری :{" "}
                  </Typography>
                  <Typography variant="subtitle1" component={"div"}>
                    شنبه تا پنجشنبه از 11 الی 19{" "}
                  </Typography>
                </Stack>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} useFlexGap flexWrap={"wrap"} spacing={1}>
                  <Typography variant="subtitle1" component={"div"}>
                    مارو در شبکه های اجتماعی دنبال کنید
                  </Typography>
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    sx={{ ml: "auto" }}
                    alignItems={"center"}
                    useFlexGap
                    flexWrap={"wrap"}
                    spacing={2}
                  >
                    <Button
                      component={NextLink}
                      target={"_blank"}
                      href={constants.social.telegram}
                      sx={{ borderRadius: 2, minWidth: "auto", p: { xs: 1, md: 0.5 } }}
                      variant="contained"
                      aria-label="Telegram-button"
                      disableElevation
                    >
                      <Telegram />
                    </Button>
                    <Button
                      component={NextLink}
                      target={"_blank"}
                      href={constants.social.instagram}
                      sx={{ borderRadius: 2, minWidth: "auto", p: { xs: 1, md: 0.5 } }}
                      variant="contained"
                      aria-label="Instagram-button"
                      disableElevation
                    >
                      <Instagram />
                    </Button>
                    <Button
                      disabled={true}
                      sx={{ borderRadius: 2, minWidth: "auto", p: { xs: 1, md: 0.5 } }}
                      variant="contained"
                      aria-label="WhatsApp-button"
                      disableElevation
                    >
                      <WhatsApp />
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={8}
              alignItems={"center"}
              justifyContent={"center"}
              alignSelf={"center"}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              <Stack
                direction={"row"}
                justifyContent={"end"}
                width={"100%"}
                alignItems={"center"}
                useFlexGap
                flexWrap={"wrap"}
                spacing={{ sm: 3, md: 4, lg: 7 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 0.5 }}>
                  <QuickSendIcon />
                  <Typography variant="subtitle1" component={"div"}>
                    ارسال سریع
                  </Typography>
                  <Typography variant="body2" component={"div"} sx={{ color: "grey.700" }}>
                    به سراسر کشور
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 0.5 }}>
                  <HeadphoneIcon />
                  <Typography variant="subtitle1" component={"div"}>
                    آماده پاسخگویی
                  </Typography>
                  <Typography variant="body2" component={"div"} sx={{ color: "grey.700" }}>
                    شنبه تا پنجشنبه
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 0.5 }}>
                  <GuaranteeIcon />
                  <Typography variant="subtitle1" component={"div"}>
                    تضمین اصالت کالا
                  </Typography>
                  <Typography variant="body2" component={"div"} sx={{ color: "grey.700" }}>
                    در هر شرایطی
                  </Typography>
                </Box>
                {/*<Box*/}
                {/*  sx={{*/}
                {/*    alignItems: "center",*/}
                {/*    justifyContent: "center",*/}
                {/*    flexDirection: "column",*/}
                {/*    gap: 0.5,*/}
                {/*    display: { xs: "none", lg: "flex" },*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <BigCarIcon />*/}
                {/*  <Typography variant="subtitle1" component={"div"}>*/}
                {/*    ارسال رایگان*/}
                {/*  </Typography>*/}
                {/*  <Typography variant="body2" component={"div"} sx={{ color: "grey.700" }}>*/}
                {/*    بالای 600هزار تومان*/}
                {/*  </Typography>*/}
                {/*</Box>*/}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container sx={{ p: { xs: 3, md: 3, lg: 4 } }} maxWidth={"xl"}>
        <Grid container spacing={{ xs: 4, md: 3 }}>
          <Grid item xs={12} sm={8} md={7} lg={4}>
            <Stack spacing={2}>
              <Box sx={{ position: "relative", height: 32, width: 143 }}>
                <Image src="/logo-with-name.svg" alt="Zibasi" fill={true} style={{ objectFit: "contain" }} />
              </Box>
              <Typography
                variant="body1"
                sx={{
                  maxWidth: {
                    xs: "auto",
                    md: 420,
                  },
                }}
              >
                در زیباسی، ما به زیبایی و سلیقه شما اهمیت می‌دهیم. با مجموعه‌ای از اکسسوری‌های جذاب و مدرن، به شما این امکان را می‌دهیم که
                هر روز به شکلی خاص و متفاوت بدرخشید. از زیورآلات شیک گرفته تا اکسسوری‌های خاص، زیباسی جایی است که هر فرد می‌تواند سبک و هویت
                خود را بیابد. به ما بپیوندید و تجربه‌ی خریدی لذت‌بخش را با ما داشته باشید!
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4} md={5} lg={3}>
            <Stack spacing={1}>
              <Typography variant="h5" component={"div"}>
                دسترسی سریع
              </Typography>
              <Link component={NextLink} href="/" underline="hover" variant="body1">
                صفحه اصلی
              </Link>
              <Link component={NextLink} href="/products" underline="hover" variant="body1">
                محصولات زیباسی
              </Link>
              <Link component={NextLink} href="/contact-us" underline="hover" variant="body1">
                تماس با ما
              </Link>
              <Link component={NextLink} href="/about-us" underline="hover" variant="body1">
                درباره ما
              </Link>
              <Link component={NextLink} href="/legal" underline="hover" variant="body1">
                قوانین و مقررات
              </Link>
              <Link component={NextLink} href="/faq" underline="hover" variant="body1">
                سوالات متداول
              </Link>
              {/*<Link component={NextLink} href="/blog" underline="hover" variant="body1">*/}
              {/*  بلاگ*/}
              {/*</Link>*/}
            </Stack>
          </Grid>
          <Grid item xs={12} md={12} lg={5} alignItems={"center"} alignSelf={"center"}>
            <Stack
              direction={"row"}
              justifyContent={{ xs: "center", lg: "end" }}
              alignItems={"center"}
              useFlexGap
              flexWrap={"wrap"}
              spacing={2}
            >
              <Box sx={{ width: 98, height: 128, position: "relative" }}>
                <a
                  referrerPolicy="origin"
                  target="_blank"
                  aria-label="Go to the enamad website"
                  href="https://trustseal.enamad.ir/?id=545893&Code=mdgWar4ov9AO5NhjsWjdS3iJYBpemynR"
                >
                  <img
                    referrerPolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=545893&Code=mdgWar4ov9AO5NhjsWjdS3iJYBpemynR"
                    alt=""
                    style={{ cursor: "pointer" }}
                    code="mdgWar4ov9AO5NhjsWjdS3iJYBpemynR"
                  />
                </a>
              </Box>
              {/*<Box sx={{ width: 98, height: 128, position: "relative" }}>*/}
              {/*  <Image src="/images/02.png" alt="Enamad" fill={true} style={{ objectFit: "contain" }} />*/}
              {/*</Box>*/}
              {/*<Box sx={{ width: 98, height: 128, position: "relative" }}>*/}
              {/*  <Image src="/images/03 1.png" alt="Enamad" fill={true} style={{ objectFit: "contain" }} />*/}
              {/*</Box>*/}
            </Stack>
          </Grid>
        </Grid>
      </Container>
      <Divider />
      <Stack p={{ xs: 1, md: 2, lg: 3 }}>
        <Typography variant="body2" textAlign={"center"}>
           کلیه حقوق این سایت برای زیباسی محفوظ است
        </Typography>
      </Stack>
    </Stack>
  );
}
